import { Link } from 'react-router-dom'
import { Headphones, Zap, ShieldCheck } from 'lucide-react'

const LEGAL_LINKS = [
  { href: '/terms',          label: 'Terms of Service' },
  { href: '/privacy-policy', label: 'Privacy Policy' },
  { href: '/disclaimer',     label: 'Disclaimer' },
  { href: '/contact',        label: 'Contact' },
  { href: '/about',          label: 'About' },
  { href: '/dmca',           label: 'DMCA Policy' },
]

const RESOURCE_LINKS = [
  { href: '/',                             label: 'Video to MP3 Converter' },
  { href: '/faqs',                         label: 'FAQs' },
  { href: '/youtube-video-downloader',     label: 'YouTube Video Downloader' },
  { href: '/instagram-video-downloader',   label: 'Instagram Video Downloader' },
  { href: '/tiktok-video-downloader',      label: 'TikTok Video Downloader' },
  { href: '/facebook-video-downloader',    label: 'Facebook Video Downloader' },
  { href: '/convert-video-to-mp3',         label: 'Convert Video to MP3' },
  { href: '/extract-audio',                label: 'Extract Audio' },
  { href: '/mp3-vs-wav',                   label: 'MP3 vs WAV Guide' },
  { href: '/mobile-convert',               label: 'Convert on Mobile' },
]

export default function Footer() {
  return (
    <footer className="border-t border-border/50 bg-card/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">

          {/* Brand — spans 2 cols */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Headphones className="w-6 h-6 text-primary" />
              <span className="font-display font-bold text-lg">FastAudio</span>
            </Link>
            <p className="text-muted-foreground max-w-sm mb-6 text-sm leading-relaxed">
              The fastest and most reliable online audio video converter on the web. High-quality audio video downloads in seconds, completely free.
            </p>
            <div className="flex gap-4 flex-wrap">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Zap className="w-4 h-4 text-accent" />
                Lightning Fast
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <ShieldCheck className="w-4 h-4 text-green-500" />
                Secure
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h2 className="font-bold mb-4 text-foreground text-sm uppercase tracking-wider">Legal</h2>
            <ul className="space-y-2.5">
              {LEGAL_LINKS.map(({ href, label }) => (
                <li key={href}>
                  <Link to={href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h2 className="font-bold mb-4 text-foreground text-sm uppercase tracking-wider">Resources</h2>
            <ul className="space-y-2.5">
              {RESOURCE_LINKS.map(({ href, label }) => (
                <li key={href}>
                  <Link to={href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} FastAudio – Free Video to MP3 Converter and Video Downloader. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground max-w-xl text-center md:text-right">
            This tool is for personal use only. Users must ensure they have rights to download content.
          </p>
        </div>
      </div>
    </footer>
  )
}
